const initialState = {
    sectionList: []
};


export const actionTypes = {
    sectionList: '[sectionList] Action'
}
  
export const SectionReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.sectionList: {
            return {
                ...state,
                sectionList: action.payload
            }
        }
        default: { 
            return state;
        }
    }
}

export const actions = {
    sectionList: (sectionList) => {
        return {
            type: actionTypes.sectionList,
            payload: sectionList
        }
    }
}